
import { servicesData } from '../../../mocks/services';

export default function Services() {
  const serviceRoutes: Record<string, string> = {
    'Web Design & Development': '/services/web-design',
    'AI Integration': '/services/ai-integration',
    'SEO Optimization': '/services/seo',
    'Social Media Marketing': '/services/social-media',
    'Google LSA + PPC': '/services/google-ads',
    'Reputation Management': '/services/reputation-management'
  };

  return (
    <section id="services" className="py-24 bg-gradient-to-br from-navy-950 via-navy-900 to-burgundy-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our <span className="text-red-500">Services</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Comprehensive digital marketing solutions designed to grow your home service business
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => (
            <a
              key={index}
              href={serviceRoutes[service.title] || '#'}
              className="group relative bg-gradient-to-br from-burgundy-900/50 to-navy-900/50 backdrop-blur-sm p-8 rounded-2xl hover:shadow-2xl hover:shadow-red-500/20 transition-all duration-300 hover:-translate-y-2 border border-white/10 cursor-pointer block"
            >
              <div className="w-16 h-16 bg-red-500 rounded-xl flex items-center justify-center mb-6 group-hover:bg-red-600 group-hover:scale-110 transition-all">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white group-hover:text-red-500 mb-4 transition-colors">
                {service.title}
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                {service.description}
              </p>
              <div className="flex items-center text-red-500 font-semibold group-hover:gap-3 transition-all">
                Learn More
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
